import { createFeature, createReducer, on } from "@ngrx/store";
import { registrationActions } from "./actions";
import {
  AccountCredentials,
  RegistrationState,
} from "@core/models/registration.interface";
import { IntentTypes } from "@shared/enums";

export const initialRegistrationState: RegistrationState = {
  isLoading: false,
  intent: IntentTypes.empty,
  validEmail: false,
  otpSent: false,
  otpMatch: false,
  validMsisdn: false,
  registered: false,
  data: {
    platform: "WIFI",
    intent: IntentTypes.empty,
    termsAccepted: false,
    marketingConsent: false,
    email: "",
    identificationDocument: {
      country: "",
      idNumber: "",
      type: "",
    },
    mobile: {
      number: "",
      otp: "",
    },
    personalInfo: {
      name: "",
      lastname: "",
      dateOfBirth: "",
    },
    accountCredentials: {
      password: "",
    },
  },
};

const registrationFeature = createFeature({
  name: "registration",
  reducer: createReducer(
    initialRegistrationState,
    //terms
    on(registrationActions.termsAccepted, (state, event) => ({
      ...state,
      data: {
        ...state.data,
        termsAccepted: event.termsStatus,
        marketingConsent: event.marketingConsent,
      },
    })),

    //lookup
    on(registrationActions.requestLookup, (state, event) => ({
      ...state,
      isLoading: true,
    })),
    on(registrationActions.requestLookupSuccess, (state, event) => ({
      ...state,
      intent: event.intent!,
      data: {
        ...state.data,
        intent: event.intent!,
        identificationDocument: {
          type: event.lookupData?.idType!,
          country: event.lookupData?.idCountry!,
          idNumber: event.lookupData?.number!,
        },
        personalInfo: {
          ...state.data.personalInfo,
          dateOfBirth: event.lookupData?.dateOfBirth!,
        },
        guid: event.guid ?? "",
        mobile: {
          number: event.mobile ?? "",
        },
      },
      isLoading: false,
    })),
    on(registrationActions.requestLookupFailed, (state, event) => ({
      ...state,
      intent: IntentTypes.empty,
      isLoading: false,
    })),

    //store personal details
    on(registrationActions.requestStorePersonalDetails, (state, event) => ({
      ...state,
      data: {
        ...state.data,
        personalInfo: {
          ...state.data.personalInfo,
          name: event.personalInfo?.name!,
          lastname: event.personalInfo?.lastname!,
        },
        mobile: event.mobile!,
      },
      isLoading: false,
    })),

    //pepclub request
    on(registrationActions.requestCheckMsisdn, (state, event) => ({
      ...state,
      isLoading: true,
    })),
    on(registrationActions.requestCheckMsisdnSuccess, (state, event) => ({
      ...state,
      validMsisdn: true,
      isLoading: false,
    })),
    on(registrationActions.requestCheckMsisdnFailed, (state, event) => ({
      ...state,
      validMsisdn: false,
      isLoading: false,
    })),

    //pepclub request
    on(registrationActions.requestPepclubCheck, (state, event) => ({
      ...state,
      isLoading: true,
    })),
    on(registrationActions.requestPepclubCheckSuccess, (state, event) => ({
      ...state,
      isLoading: false,
    })),
    on(registrationActions.requestPepclubCheckFailed, (state, event) => ({
      ...state,
      isLoading: false,
    })),

    //otp request
    on(registrationActions.requestOTPViaMsisdn, (state, event) => ({
      ...state,
      isLoading: true,
    })),
    on(registrationActions.requestOTPViaMsisdnSuccess, (state, event) => ({
      ...state,
      otpSent: true,
      isLoading: false,
    })),
    on(registrationActions.requestOTPViaMsisdnFailed, (state, event) => ({
      ...state,
      otpSent: false,
      isLoading: false,
    })),

    //otp validation
    on(registrationActions.requestOTPValidation, (state, event) => ({
      ...state,
      isLoading: true,
    })),
    on(registrationActions.requestOTPValidationSuccess, (state, event) => ({
      ...state,
      otpMatch: true,
      data: {
        ...state.data,
        mobile: {
          ...state.data.mobile,
          otp: event.otp,
        },
      },
      isLoading: false,
    })),
    on(registrationActions.requestOTPValidationFailed, (state, event) => ({
      ...state,
      otpMatch: false,
      isLoading: false,
    })),

    //Email Validation

    on(registrationActions.requestEmailValidation, (state, event) => ({
      ...state,
      validEmail: false,
      isLoading: true,
      data: {
        ...state.data,
        email: event.email,
      },
    })),

    on(registrationActions.requestEmailValidationSuccess, (state, event) => ({
      ...state,
      validEmail: true,
      isLoading: false,
    })),

    on(registrationActions.requestEmailValidationFailed, (state, event) => ({
      ...state,
      validEmail: false,
      isLoading: false,
    })),

    //Store password

    on(registrationActions.requestStorePassword, (state, event) => ({
      ...state,
      data: {
        ...state.data,
        accountCredentials: {
          password: event.password,
        },
      },
    })),

    //registration
    on(registrationActions.requestRegistration, (state, event) => ({
      ...state,
      isLoading: true,
    })),
    on(registrationActions.requestRegistrationSuccess, (state, event) => ({
      ...state,
      registered: true,
      isLoading: false,
    })),
    on(registrationActions.requestRegistrationFailed, (state, event) => ({
      ...state,
      registered: false,
      isLoading: false,
    })),

    //reset steps

    on(registrationActions.requestResetIntent, (state) => ({
      ...state,
      intent: IntentTypes.empty,
    })),
    on(registrationActions.requestResetOtpSent, (state) => ({
      ...state,
      otpSent: false,
    })),
    on(registrationActions.requestResetOtpMatch, (state) => ({
      ...state,
      otpMatch: false,
    })),
    on(registrationActions.requestResetEmail, (state) => ({
      ...state,
      validEmail: false,
    })),
    on(registrationActions.requestResetPassword, (state) => ({
      ...state,
      data: {
        ...state.data,
        accountCredentials: initialRegistrationState.data.accountCredentials,
      },
    }))
  ),
});

export const { name: registrationFeatureKey, reducer: registrationReducer } =
  registrationFeature;
